'use strict';

const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;

exports.cubicBezierAsString = cubicBezierAsString;
//# sourceMappingURL=cubic-bezier.cjs.map
